import React from 'react';
import { useEffect, useState } from 'react';
import './NotFoundHeader.css';
import { HEADER_HEIGHT } from '../../constants';
import { useNavigate } from 'react-router-dom';

export function NotFoundHeader() {
    const navigate = useNavigate();
    const handleGoToFeed = () => {
        navigate('/feed')
    }
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <>
            {windowWidth > 768 ? (
                <div className="header" style={{ height: `${HEADER_HEIGHT}px` }}>
                    <div className="notFoundHeaderContents">
                        <h1 className="notFoundTitle" onClick={handleGoToFeed}>Lava
                            <img className="notFoundTitleLogo" src={require('../../assets/images/logo-white.png')} />
                            amp
                        </h1>
                    </div>
                </div>
            ) : (
                <div className="header" style={{ height: `${HEADER_HEIGHT}px` }}>
                    <div className="notFoundHeaderContents">
                        <h1 className="notFoundTitle" style={{ fontSize: '32px', marginBottom: '5px', width: '100%', textAlign: 'center' }} onClick={handleGoToFeed}>
                            Lava
                            <img className="notFoundTitleLogo" src={require('../../assets/images/logo-white.png')} />
                            amp
                        </h1>
                    </div>
                </div>
            )}
        </>
    );
}